<template v-slot="scope">
  <div class="MainVisual__back">
    <div class="MainVisual">
      <div class="MainVisual__area" />
    </div>
    <div class="contents">
      <section class="section--pb-md Class__con-tour">
        <div>
          <div class="inner">
            <h2 class="Head Head--cl01 Head--sp-cl01 Head--mg_md">
              <span
                class="Head__main Head--md"
              >Today’s class</span><br><span class="Head__main_jp">今日のクラス</span>
            </h2>
          </div>
          <div class="Card__inner inner ft_en">
            <div class="Card__area Card__schedule_area">
              <div class="Card__box_list_main Card__box--open">
                <div class="Card__box_time">
                  {{ featuredItem.learning_time }}
                </div>
                <div class="Label__op Card__box_op_label">
                  開催中
                </div>
                <div
                  class="Card__box Card__box--lg Card__box_first"
                  :style="parseCssVars(featuredItem.master_program_category)"
                >
                  <div class="Label Label__time Card__box_time_label">
                    {{ featuredItem.time }} min
                  </div>
                  <div class="Card__box_label">
                    <span
                      class="Card__box_label_class"
                    >{{ featuredItem.class }}</span><span
                      class="Card__box_label_name"
                    >{{ featuredItem.master_instructor.name }}</span>
                  </div>
                </div>
              </div>
              <div
                v-for="(item,key) of listScheduleToDay"
                :key="key"
                class="Card__box_list"
              >
                <div class="Card__date_area">
                  <div class="Card__date_box">
                    <span class="Card__date_box_tx">{{ handleDateToDay(item.date) }}</span>
                    <span class="Card__day_tx_sub">&#040;{{ handleShowDate(item.date) }}&#041;</span>
                  </div>
                </div>
                <div class="Card__box_top">
                  <div class="Card__box_time">
                    {{ item.learning_time }}
                  </div>
                  <div class="Label Label__time Card__box_time_label_secondary">
                    {{ item.time }} min
                  </div>
                </div>
                <div class="Card__box Card__box--sm" :style="parseCssVars(item.master_program_category)">
                  <div class="Card__box_label Card__box_label_secondary">
                    <span class="Card__box_label_class">{{ item.class }}</span>
                    <span class="Card__box_label_name">{{ item.master_instructor.name }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <modal-tutorial :is-open="isOpenTutorialModal" @startTour="startHomeTour" @close="closeModal" />
    <v-tour
      name="homeTour"
      :steps="steps"
      :options="tourOptions"
      :callbacks="tourCallbacks"
    >
      <template v-slot:default="tour">
        <v-step
          v-if="tour.steps[tour.currentStep]"
          :key="tour.currentStep"
          :step="tour.steps[tour.currentStep]"
          :previous-step="tour.previousStep"
          :next-step="tour.nextStep"
          :stop="tour.stop"
          :skip="tour.skip"
          :is-first="tour.isFirst"
          :is-last="tour.isLast"
          :labels="tour.labels"
          :enabled-buttons="tour.enabledButtons"
          :highlight="tour.highlight"
        >
          <template #content>
            <div class="v-step__close" @click="tour.skip">
              <span class="v-step__button-close" />
            </div>
            <div class="v-step__content">
              <!-- eslint-disable vue/no-v-html -->
              <div v-html="tour.steps[tour.currentStep].content" />
              <!--eslint-enable-->
            </div>
          </template>
          <template #actions>
            <div class="v-step__buttons">
              <button v-if="!tour.isFirst && !tour.isLast" class="v-step__button v-step__button-previous" @click.prevent="tour.previousStep">
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" class="bi bi-caret-left-fill" viewBox="0 0 16 16">
                  <path d="m3.86 8.753 5.482 4.796c.646.566 1.658.106 1.658-.753V3.204a1 1 0 0 0-1.659-.753l-5.48 4.796a1 1 0 0 0 0 1.506z" />
                </svg>
              </button>
              <button v-if="!tour.isLast" class="v-step__button v-step__button-next" @click.prevent="tour.nextStep">
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" class="bi bi-caret-right-fill" viewBox="0 0 16 16">
                  <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                </svg>
              </button>
              <button v-if="tour.isLast" class="v-step__button v-step__button-stop" @click.prevent="tour.finish">
                HOMEにもどる
              </button>
            </div>
          </template>
        </v-step>
      </template>
    </v-tour>
  </div>
</template>

<script>
import ModalTutorial from '@/views/components/modals/ModalTutorial.vue'
import authService from '@/services/authService'
import { parseCssVars } from '@/helpers/programCategory'
import moment from 'moment'

export default {
  name: 'HomeTour',
  components: {
    ModalTutorial
  },
  data() {
    return {
      isOpenTutorialModal: true,
      featuredItem: {
        id: 1,
        time: 30,
        class: 'Basic',
        learning_time: '09:00',
        learning_day: '1',
        master_program_category: {
          name: 'Basic',
          image_url: '/assets/img/000_Class_pic_Basic.jpg',
          icon_url: '/assets/img/icon_lesson01.png',
          background_color: '#6e9bc5'
        },
        master_instructor: {
          name: 'Eri',
          image_url: '/assets/img/instructors/eri.png'
        }
      },
      listScheduleToDay: [
        {
          id: 2,
          time: 30,
          class: 'Focus',
          learning_time: '10:00',
          learning_day: '1',
          master_program_category: {
            name: 'Focus',
            image_url: '/assets/img/002_Class_pic_Focus.jpg',
            icon_url: '/assets/img/icon_lesson03.png',
            background_color: '#8ac88d'
          },
          master_instructor: {
            name: 'Emi',
            image_url: '/assets/img/instructors/emi.png'
          }
        },
        {
          id: 3,
          time: 30,
          class: 'Heart',
          learning_time: '11:00',
          learning_day: '1',
          master_program_category: {
            name: 'Heart',
            image_url: '/assets/img/003_Class_pic_Heart.jpg',
            icon_url: '/assets/img/icon_lesson05.png',
            background_color: '#ee86a1'
          },
          master_instructor: {
            name: 'Aoi',
            image_url: '/assets/img/instructors/aoi.png'
          }
        },
        {
          id: 4,
          time: 15,
          class: 'Breath',
          learning_time: '12:00',
          learning_day: '1',
          master_program_category: {
            name: 'Breath',
            image_url: '/assets/img/004_Class_pic_Breath.jpg',
            icon_url: '/assets/img/icon_lesson05.png',
            background_color: '#86bbdb'
          },
          master_instructor: {
            name: 'Miyu',
            image_url: '/assets/img/instructors/miyu.png'
          }
        },
        {
          id: 5,
          time: 30,
          class: 'Advanced',
          learning_time: '13:00',
          learning_day: '1',
          master_program_category: {
            name: 'Advanced',
            image_url: '/assets/img/005_Class_pic_Advanced.jpg',
            icon_url: '/assets/img/icon_lesson06.png',
            background_color: '#eb615a'
          },
          master_instructor: {
            name: 'Masao',
            image_url: '/assets/img/instructors/masao.png'
          }
        },
        {
          id: 6,
          time: 15,
          class: 'Kids',
          learning_time: '14:00',
          learning_day: '1',
          master_program_category: {
            name: 'Kids',
            image_url: '/assets/img/006_Class_pic_Kids.jpg',
            icon_url: '/assets/img/icon_lesson07.png',
            background_color: '#ee86a1'
          },
          master_instructor: {
            name: 'Sou',
            image_url: '/assets/img/instructors/sou.png'
          }
        }
      ],
      steps: [
        {
          target: '.Card__box_list_main',
          content: `開催中クラスはここから参加！
            <br>
            <span style="font-size: 10px;">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-exclamation-circle-fill" viewBox="0 0 16 16">
                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M8 4a.905.905 0 0 0-.9.995l.35 3.507a.552.552 0 0 0 1.1 0l.35-3.507A.905.905 0 0 0 8 4m.002 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2"/>
              </svg>
              「開催中」表記がない場合はクラスの説明文が表示されます
            </span>`,
          params: {
            enableScrolling: false
          }
        },
        {
          target: '.Card__box_list',
          content: 'クラス名をタップでクラスの概要をチェック',
          params: {
            enableScrolling: false
          }
        },
        {
          target: '.Header__menu_link_tv',
          content: 'アーカイブ受講は こちらから'
        },
        {
          target: '.Header__menu_link_checker',
          content: 'マインドフルチェッカーで 今のストレス値を計測！'
        },
        {
          target: '.Header__menu_link_other',
          content: `MELONの使い方を再確認した<br>いときはこちらから
                <br>
                <span style="font-size: 10px;">
                  登録後2週間はHOME下部のバナーからもご確認いただけます
                </span>`,
          params: {
            enableScrolling: false
          }
        },
        {
          target: false,
          content: '<p>Done！<br>MELONをお楽しみください</p><img src="/assets/img/tour_done.png" alt="done" />',
          params: {
            highlight: false,
            enabledButtons: {
              buttonPrevious: false
            }
          }
        }
      ],
      tourOptions: {
        highlight: true
      },
      tourCallbacks: {
        onFinish: this.finishTour,
        onSkip: this.finishTour
      }
    }
  },
  mounted() {
    if (this.$store.state.user.tutorialCompleted) {
      return
    }
    authService.updateTutorialCompleted()
    this.$store.dispatch('user/setTutorialCompleted', 1)
  },
  created() {
  },
  methods: {
    handleDateToDay(date) {
      return moment(date).format('M.D')
    },
    handleShowDate(date) {
      return moment(date).format('ddd')
    },
    closeModal() {
      this.isOpenTutorialModal = false
    },
    startHomeTour() {
      this.$tours['homeTour'].start()
    },
    finishTour() {
      this.$tours['homeTour'].stop()
      this.$nextTick(() => {
        this.$router.push('/')
      })
    },
    parseCssVars: parseCssVars
  }
}
</script>
<style lang="scss">
.v-tour__target--highlighted.v-tour__target--relative {
  border: transparent solid 10px;
  border-radius: 10px;
  pointer-events: none;
  -webkit-box-shadow: 0 0 0 99999px rgba(0,0,0,.7);
  box-shadow: 0 0 0 99999px rgba(0,0,0,.7);
}
.v-tour--active .v-step.v-step--sticky{
  background-color: #fff;
  color: #4A81AD;
  font-family: 'Inter', sans-serif;
  font-size: 18px;
  line-height: 1.8;
  font-weight: 600;
  -webkit-box-shadow: 0 0 0 99999px rgba(0,0,0,.7);
  box-shadow: 0 0 0 99999px rgba(0,0,0,.7);
  img {
    max-width: 280px;
  }
  .v-step__button {
    width: 200px;
    height: auto;
    font-family: 'Inter', sans-serif;
    font-size: 18px;
    line-height: 1.5;
    color: #fff;
    background-color: #4A81AD;
    border-radius: 24px;
  }
}
.v-tour--active .v-tour {
  .v-step {
    background-color: #fff;
    color: #4A81AD;
    max-width: 360px;
  }
  .v-step__button {
    font-family: 'Inter', sans-serif;
    font-size: 2rem;
    color: #4A81AD;
    border: none;
  }
  .v-step__content {
    font-family: 'Inter', sans-serif;
    font-weight: 600;
    line-height: 1.5;
    margin-top: 1rem;
  }
  .v-step__close {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 999;
    cursor: pointer;
    padding: 12px;
  }
  .v-step__button-close {
  position: relative;
  display: block;
  width: 12px;
  height: 12px;
  }
  .v-step__button-close::before, .v-step__button-close::after {
    content: "";
    display: block;
    width: 100%;
    height: 1px;
    background: #958A80;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
    -webkit-transform-origin: 0% 50%;
    -ms-transform-origin: 0% 50%;
    transform-origin: 0% 50%;
    position: absolute;
    top: 14%;
    left: 14%;
  }
  .v-step__button-close::after {
    -webkit-transform: rotate(-45deg);
    -ms-transform: rotate(-45deg);
    transform: rotate(-45deg);
    -webkit-transform-origin: 100% 50%;
    -ms-transform-origin: 100% 50%;
    transform-origin: 100% 50%;
    left: auto;
    right: 14%;
  }
}
</style>
<style lang="scss" scoped>
.MainVisual__area {
  background: url('/assets/img/kv.png') center top 50% no-repeat;
}
@media (min-width: 768px) {
  .MainVisual__area {
    display: none;
  }
}
@media (max-width: 490px) {
  .MainVisual__area {
    height: 60vh;
  }
  .Class__con-tour {
    margin-top: -50vh;
  }
}
</style>
